export default __webpack_public_path__ + "static/media/CUPRA.e45b03fa.png";